// Structured logging for the socket layer. Console in dev; Sentry
// breadcrumbs in prod (so errors uploaded with the user's session
// include the recent socket activity).
//
// Usage:
//   socketLog('info',  'connected',     { namespace: 'collaboration' });
//   socketLog('warn',  'emit_retry',    { event, attempt, code, delay });
//   socketLog('error', 'reconnect_lost',{ namespace, attempts });
//
// `data` should be a plain object — no PII, no whole payloads.

const LEVELS = { info: 'info', warn: 'warning', error: 'error' };

const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development';

function consoleFor(level) {
    if (level === 'error') return console.error;
    if (level === 'warn')  return console.warn;
    return console.log;
}

let sentryAddBreadcrumb = null;
try {
    // Sentry is optional — failing to import is non-fatal.
    /* eslint-disable global-require */
    const Sentry = require('@sentry/react');
    /* eslint-enable global-require */
    sentryAddBreadcrumb = Sentry?.addBreadcrumb?.bind(Sentry) || null;
} catch (_) {
    sentryAddBreadcrumb = null;
}

export function socketLog(level, event, data) {
    if (isDev) {
        const fn = consoleFor(level);
        fn(`[socket] ${event}`, data || '');
    }
    if (sentryAddBreadcrumb) {
        sentryAddBreadcrumb({
            category: 'socket',
            type: 'info',
            level: LEVELS[level] || 'info',
            message: event,
            data: data || {},
        });
    }
}
